// extracted by mini-css-extract-plugin
export default {"chandradeo-battery-profile":"App_chandradeo-battery-profile__sz2w9"};